import { HttpContextToken } from '@angular/common/http';

export type ErrorByStatusType = Record<number, string>;

export const HttpErrorStatusRu: ErrorByStatusType = {
  // 4xx — Client Errors
  400: 'Некорректный запрос',
  401: 'Необходима аутентификация',
  402: 'Требуется оплата (зарезервировано)',
  403: 'Доступ запрещён',
  404: 'Ресурс не найден',
  405: 'Метод не поддерживается',
  406: 'Неприемлемый формат данных',
  407: 'Требуется аутентификация прокси',
  408: 'Превышено время ожидания запроса',
  409: 'Конфликт запроса с состоянием сервера',
  410: 'Ресурс удалён',
  411: 'Отсутствует заголовок длины контента',
  412: 'Условие запроса не выполнено',
  413: 'Слишком большой размер данных',
  414: 'Слишком длинный URI',
  415: 'Неподдерживаемый тип данных',
  416: 'Диапазон недопустим',
  417: 'Ожидание не выполнено',
  418: 'Шуточный код (RFC 2324)',
  422: 'Ошибка валидации данных',
  425: 'Сервер не готов обработать запрос',
  426: 'Требуется обновление протокола',
  428: 'Требуется предусловие',
  429: 'Слишком много запросов',
  431: 'Заголовки слишком большие',
  451: 'Доступ запрещён по юридическим причинам',

  // 5xxServer Errors
  500: 'Внутренняя ошибка сервера',
  501: 'Метод не реализован',
  502: 'Ошибка шлюза',
  503: 'Сервис недоступен',
  504: 'Превышено время ожидания шлюза',
  505: 'Версия HTTP не поддерживается',
  507: 'Недостаточно памяти на сервере',
  508: 'Обнаружен цикл при обработке запроса',
  510: 'Требуется расширение запроса',
  511: 'Требуется сетевая аутентификация',
};

export const HttpErrorStatusEn: ErrorByStatusType = {
  // 4xx — Client Errors
  400: 'Bad Request',
  401: 'Unauthorized',
  402: 'Payment Required',
  403: 'Forbidden',
  404: 'Not Found',
  405: 'Method Not Allowed',
  406: 'Not Acceptable',
  407: 'Proxy Authentication Required',
  408: 'Request Timeout',
  409: 'Conflict',
  410: 'Gone',
  411: 'Length Required',
  412: 'Precondition Failed',
  413: 'Payload Too Large',
  414: 'URI Too Long',
  415: 'Unsupported Media Type',
  416: 'Range Not Satisfiable',
  417: 'Expectation Failed',
  418: "I'm a teapot",
  422: 'Unprocessable Entity',
  425: 'Too Early',
  426: 'Upgrade Required',
  428: 'Precondition Required',
  429: 'Too Many Requests',
  431: 'Request Header Fields Too Large',
  451: 'Unavailable For Legal Reasons',

  // 5xx — Server Errors
  500: 'Internal Server Error',
  501: 'Not Implemented',
  502: 'Bad Gateway',
  503: 'Service Unavailable',
  504: 'Gateway Timeout',
  505: 'HTTP Version Not Supported',
  507: 'Insufficient Storage',
  508: 'Loop Detected',
  510: 'Not Extended',
  511: 'Network Authentication Required',
};

/**
 * Создан для ErrorInterceptor
 * Конфиг позволяет вывести ошибку через сервис натификаций
 */
export interface HttpErrorConfig {
  /**
   * Флаг включения
   **/
  disabled?: boolean;
  /*
   * Статический заголовок ошибки
   **/
  title: string;
  /*
   * Статический ПОДзаголовок ошибки
   **/
  staticMessage?: string;
  /*
   * Список текстовок по коду ошибки. Используется только если нет поля staticMessage
   **/
  customErrorsByStatus?: ErrorByStatusType;
}

export const HTTP_ERROR_CONTEXT = new HttpContextToken<HttpErrorConfig>(() => ({
  title: 'Ошибка',
  customErrorsByStatus: HttpErrorStatusRu,
}));
